const CustomDropDownStyles: any = {
    option: (provided: any, state: any) => {
        return {
            ...provided,
            fontSize: '15px',
            padding: '4px 12px',
            backgroundColor: state.isSelected ? "#008964" : "white",
            color: state.isSelected ? "white" : "#4D4D4D",

        }
    },
    indicatorSeparator: (provided: any, state: any) => { },
    indicatorsContainer: (provided: any, state: any) => {
        return {
            ...provided,
            height: 27,
            padding: 0,

        }
    },
    control: (provided: any, state: any) => {
        return {
            ...provided,
            minHeight: 35,
            border: "1px solid #e4e4e4",
            height: 30,
            width: "100%",
            fontSize: '15px',
            backgroundColor: '#f7f7f7',
            borderRadius: 0,
            borderColor: state.isFocused && "",
            // color:'#4D4D4D',
            boxShadow: 0,
            textAlignLast: "left",
            '&:hover': {
                border: '0 !important',
            },
            selectProps: {
                backgroundColor: "#008964",
                color: '#ffffff'
            }
        }
    },
    menu: (provided: any, state: any) => {
        return {
            ...provided,
            borderRadius: 0,
        }
    },
    placeholder: (provided: any, state: any) => {
        return {
            ...provided,
            textAlign: "center",
        }
    },
    singleValue: (provided: any, state: any) => {
        return {
            ...provided,
            opacity: state.isDisabled ? 0.5 : 1,
            transition: 'opacity 300ms',
        }
    },
}

export { CustomDropDownStyles}